import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import { fetchDataList } from "../../api";
import parseHTML from "../../helpers/parseHTML";

function Footer() {
  const { data: data } = useQuery(["general-disclaimer"], () =>
    fetchDataList("general")
  );

  return (
    <div className="text-muted footer bg-dark">
      <nav className="navbar navbar-expand navbar-dark bg-dark">
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto">
            <li className="nav-item">
              <Link to="/imprint" className="nav-link">
                Impressum
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/legal-notice" className="nav-link">
                Rechtliches
              </Link>
            </li>
          </ul>
        </div>
      </nav>

      <div className="footer-divider" />
      <div className="footer-disclaimer navbar">
        <p className="footer-disclaimer-data">
          {data?.disclaimer && parseHTML(data?.disclaimer, data)}
        </p>
      </div>
    </div>
  );
}

export default Footer;
